import { Container, Paper, Box, Typography } from "@wealthx/ui";
import { CreditCardOff as CreditCardOffIcon } from "@mui/icons-material";

import { useCompanySubscription } from "../../hooks/billing.hooks";
import { useCompanyInfo } from "../../hooks/company.hooks.ts";
import LoadingBackdrop from "../loading-backdrop";
import {
  borderColor,
  secondaryTextColor,
  textColor,
  whiteColor,
} from "../../scss/colors.module.scss";
import {
  customFontSize16,
  customFontSizeLg,
  customFontSizeSubtitle,
  fontBold,
  fontRegular,
  fontSemiBold,
} from "../../scss/fonts.module.scss";

import "./subscription-gate.scss";

const SubscriptionGate = ({ children }: { children: React.ReactNode }) => {
  const { data: companyInfo, isLoading: isCompanyInfoLoading } = useCompanyInfo();
  const {
    data: subscription,
    isLoading: isSubscriptionLoading,
    isFetched: isSubscriptionFetched,
  } = useCompanySubscription(companyInfo?.id) as any;

  // Wait for subscription data to load
  if ((isSubscriptionLoading && !isSubscriptionFetched) || isCompanyInfoLoading) {
    return <LoadingBackdrop />;
  }
  // If there's an active subscription, render children
  if (subscription?.lago_id || !companyInfo?.domain) {
    return children;
  }

  // No active subscription — show blocking screen
  return (
    <Box className="subscription-gate-container">
      <Container maxWidth="md" sx={{ display: "flex", justifyContent: "center" }}>
        <Paper className="subscription-gate-paper" elevation={0}>
          <div className="subscription-gate-illustration">
            <CreditCardOffIcon className="subscription-gate-illustration-icon" />
          </div>

          <Typography className="subscription-gate-title" component="h2">
            No Active Subscription
          </Typography>

          <Typography className="subscription-gate-subtitle" component="p">
            Your company does not have an active subscription plan. Please contact your system
            administrator to assign a new plan.
          </Typography>

          <Box mt={2}>
            <Typography className="subscription-gate-help-text">
              Contact your system administrator
            </Typography>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default SubscriptionGate;
